<div class="storage-files-upload">
    <div [hidden]="!multiple && files.queue.length !== 0">
        <!-- new drop zone https://www.npmjs.com/package/ngx-file-drop -->
        <ngx-file-drop multiple="multiple" dropZoneLabel="Drop files here" dropZoneClassName="drag"
            contentClassName="drag-content" (onFileDrop)="dropped($event)" (onFileOver)="fileOver($event)"
            (onFileLeave)="fileLeave($event)">
            <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                <div (click)="openFileSelector()">
                    <span>Drag files or click here</span>
                </div>
            </ng-template>
        </ngx-file-drop>
        <!-- /end of new drop zone-->
    </div>

    <ul>
        <li class="storage-files-upload-li" *ngFor="let file of files.queue" [hidden]="file.status == 2 && hiddenUploaded">
            <div class="progressbar" *ngIf="file.status == 0" role="progressbar"
                [ngStyle]="{ 'width.%': file.progress }"><span>Progress bar</span>
            </div>
            <div class="ctn" *ngIf="file.status != 2"
                [ngClass]="{'complete': file.status == 2, 'fail': file.status == 1}">
                <core-helpers-box-list-item [close]="true" (onCloseClick)="removeFile(file)"
                    [mainText]="getViewName(file)"></core-helpers-box-list-item>
            </div>
            <core-storage-file-uploaded-list-item *ngIf="file.status == 2" [remove]="true" (onRemove)="removeFile(file)"
                [file]="file.metadata"></core-storage-file-uploaded-list-item>
        </li>
    </ul>
</div>